import React, { useState, useCallback } from 'react';
import { Toast } from '@shopify/polaris';

const ToastFunc = (props) => {
  const [active, setActive] = useState(props.onDismiss);

  const toggleActive = useCallback(() => setActive((active) => !active), []);

  const toastMarkup = active ? (
    <Toast duration={props.duration} content={props.content} onDismiss={toggleActive} error={props.error} />
  ) : null;

  return (
    <div>
      {toastMarkup}
    </div>
  );
}

export default ToastFunc